var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.70711 6.29289C1.31658 5.90237 0.683418 5.90237 0.292893 6.29289C-0.0976311 6.68342 -0.0976311 7.31658 0.292893 7.70711L5.29289 12.7071C5.68342 13.0976 6.31658 13.0976 6.70711 12.7071L17.7071 1.70711C18.0976 1.31658 18.0976 0.683418 17.7071 0.292893C17.3166 -0.0976311 16.6834 -0.0976311 16.2929 0.292893L6 10.5858L1.70711 6.29289Z","transform":"translate(3 5)","fill":"black"}));
}

Check.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Check;

Check.default = Check;
